if (!customElements.get('print-size-guide')) {
  customElements.define(
    'print-size-guide',
    class PrintSizeGuide extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-size]'));
        this.name = this.querySelector('[data-size-name]');
        this.dims = this.querySelector('[data-size-dims]');
        this.tip = this.querySelector('[data-size-tip]');

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-size]');
          if (button) this.choose(button.dataset.size);
        });

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data: { target } }) => {
          if (target?.closest('.product-form__input--sizes')) this.select(target.value);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      // Selects the size in the main product form so price, button and URL update with it.
      choose(size) {
        const input = Array.from(
          document.querySelectorAll('product-info[id^="MainProduct"] .product-form__input--sizes input[type="radio"]')
        ).find((radio) => radio.value === size);

        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.select(size);
      }

      select(size) {
        const selected = this.buttons.find((button) => button.dataset.size === size);
        if (!selected) return;

        this.buttons.forEach((button) => button.setAttribute('aria-pressed', button === selected));
        this.name.textContent = size;
        this.dims.textContent = selected.dataset.dims;
        this.tip.textContent = selected.dataset.tip;
      }
    }
  );
}
